import * as React from 'react';
import { ServiceSummary } from '../../../features/service-summary';
const PriorityBoarding = ({ onServiceDelete }) => {
    return (React.createElement(ServiceSummary, { serviceType: "PriorityBoarding", onDelete: onServiceDelete }, children => children && React.createElement("span", null, children)));
};
export default PriorityBoarding;
